export class IRequestBase {
  public Headers: any;
}
